const rechargeList = {
  path: 'rechargeList',
  component: resolve => require(['@/pages/admin/trading/rechargeList'], resolve)
}

export default rechargeList
